import styled from "styled-components";


export const StyledModel = styled.div`


    margin: auto auto;
    height: 650px;
    width: 500px;
    border-radius: 20px;
    position: relative;
    display: flex;

    .modelArea{
        position: relative;
        display: flex;
        justify-content: center;
        height: 650px;
        width: 500px;
        
        img{
            height: 100%;
            max-width: 100%;
        }
    }

    .clothContainer{
        position: absolute;
    }

`

